import groupBy from 'lodash.groupby';
import partition from 'lodash.partition';
import { Segment } from '../../v2/common/components/filter/filterbar/types';
import { Operations } from '../../v2/types';
import {
  filterToDataFieldWithDataType,
  getKeyFromDataFieldWithDataType,
  isHierarchical,
} from '../../v2/utils';

// "Others" bucket filters for PBS segmentation: restrict to employees matching
// none of the selected segment values.
// Same-dimension segments are merged into one multi-value NOT_EQUAL filter:
// one NOT_EQUAL item per value builds a left-deep AND chain whose depth equals
// the segment count, which overflows the SQL serializer's recursion for
// high-cardinality dimensions like Manager, so must be avoided!
export const getNegatedSegmentationFilters = (
  segments: Segment[]
): Segment[] => {
  const [mergeable, unmergeable] = partition(
    segments,
    (s) => !isHierarchical(filterToDataFieldWithDataType(s)) && !s.sql
  );
  const mergedByDimension = Object.values(
    groupBy(mergeable, (s) =>
      getKeyFromDataFieldWithDataType(filterToDataFieldWithDataType(s))
    )
  ).map((dimensionSegments) => ({
    ...dimensionSegments[0],
    operation: Operations.NOT_EQUAL,
    values: Array.from(new Set(dimensionSegments.flatMap((s) => s.values))),
  }));
  return [
    ...mergedByDimension,
    ...unmergeable.map((s) => ({ ...s, operation: Operations.NOT_EQUAL })),
  ];
};
